import React, { useContext } from 'react';

import isEmpty from 'lodash/isEmpty';
import isNull from 'lodash/isNull';

import Toggle from '@atlaskit/toggle';

import { DashboardContext } from '@qality/common-pages';

import QalityPagination from '../../QalityPagination';
import { Gadget, GadgetHeader } from '../gadgets.styled';
import {
  QAlityPaginationStyled,
  TableHeaderStyled,
  ToggleStyled,
  UnfinishedTestCaseExecutionsStyled,
} from './UnfinishedTestCaseExecutions.styled';
import UnfinishedTestCaseExecutionsTable from './UnfinishedTestCaseExecutionsTable';

export default function UnfinishedTestCaseExecutions() {
  const {
    showAssignedToMeOnly,
    toggleShowAssignedToMeOnly,
    unfinishedTestCaseExecutions,
    pagination,
    isLoadingUnfinishedTestCaseExecutions,
    handlePageChange,
  } = useContext(DashboardContext);

  return (
    <UnfinishedTestCaseExecutionsStyled>
      <GadgetHeader>
        <h4>Unfinished test case executions</h4>
      </GadgetHeader>
      <Gadget>
        <TableHeaderStyled>
          <h5>{pagination?.totalElements ?? 0} unfinished executions</h5>
          {showAssignedToMeOnly != undefined && (
            <ToggleStyled>
              <Toggle
                onChange={toggleShowAssignedToMeOnly}
                isChecked={showAssignedToMeOnly}
              />
              Show assigned to me only
            </ToggleStyled>
          )}
        </TableHeaderStyled>
        {unfinishedTestCaseExecutions && (
          <UnfinishedTestCaseExecutionsTable
            unfinishedTestCaseExecutionsData={unfinishedTestCaseExecutions}
            isLoading={isLoadingUnfinishedTestCaseExecutions}
          />
        )}
        {!isLoadingUnfinishedTestCaseExecutions &&
        !isNull(pagination) &&
        !isEmpty(pagination) &&
        !isEmpty(unfinishedTestCaseExecutions) ? (
          <QAlityPaginationStyled>
            <QalityPagination
              pagination={pagination}
              handleChange={handlePageChange}
              customClassName=''
            />
          </QAlityPaginationStyled>
        ) : null}
      </Gadget>
    </UnfinishedTestCaseExecutionsStyled>
  );
}
